export default __webpack_public_path__ + "static/media/MetafightWinner-min.1c104e92.png";